import { PROPERTIES } from './valamar-theme';

export default function PropertySelector({ value, onChange }) {
  return (
    <select
      className="demo-select"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      aria-label="Select property"
    >
      {PROPERTIES.map((p) => (
        <option key={p.id} value={p.id}>
          {p.shortName}
        </option>
      ))}
    </select>
  );
}

export function getPropertyById(id) {
  return PROPERTIES.find((p) => p.id === id) ?? PROPERTIES[0];
}
